import { OldIconName } from '../types/footer'

import YouTubeLogo from '@/assets/logos/youtube-logo'
import InstagramLogo from '@/assets/logos/instagram-logo'
import XLogo from '@/assets/logos/x-logo'
import LineLogo from '@/assets/logos/line-logo'
import FacebookLogo from '@/assets/logos/facebook-logo'
import TikTokLogo from '@/assets/logos/tiktok-logo'
import ThreadLogo from '@/assets/logos/thread-logo'
import WeChatLogo from '@/assets/logos/wechat-logo'
import CellIcon from '@/components/cell/atoms/Icon'
import { IconPack } from '@/components/cell/atoms/Icon/enum'
import KakaoTalkLogo from '@/assets/logos/kakaotalk-logo'

export const getFooterIcon = (name: IconPack | OldIconName) => {
  if (Object.values(IconPack).includes(name as IconPack)) {
    return <CellIcon name={name as IconPack} width={32} height={32} />
  }

  switch (name) {
    case 'youtube':
      return <YouTubeLogo width={32} height={32} />
    case 'instagram':
      return <InstagramLogo width={32} height={32} />
    case 'twitter':
      return <XLogo width={32} height={32} />
    case 'line':
      return <LineLogo width={32} height={32} />
    case 'facebook':
      return <FacebookLogo width={32} height={32} />
    case 'tiktok':
      return <TikTokLogo width={32} height={32} />
    case 'threads':
      return <ThreadLogo width={32} height={32} />
    case 'wechat':
      return <WeChatLogo width={32} height={32} />
    case 'kakaotalk':
      return <KakaoTalkLogo width={32} height={32} />
    default:
      return <></>
  }
}
